export default __webpack_public_path__ + "static/mountains-3d2925ab1dcaf334d377fafe0bac42d9.webm";